import { ClothingSizes } from "../../../Interfaces/FundraiserRole";

const clothing_sizes: ClothingSizes = {
  "450": [
    {
      db_name: "youth_small",
      display_name: "Youth Small",
      up_charge: 0,
    },
    {
      db_name: "youth_medium",
      display_name: "Youth Medium",
      up_charge: 0,
    },
    {
      db_name: "youth_large",
      display_name: "Youth Large",
      up_charge: 0,
    },
    {
      db_name: "adult_small",
      display_name: "Adult Small",
      up_charge: 0,
    },
    {
      db_name: "adult_medium",
      display_name: "Adult Medium",
      up_charge: 0,
    },
    {
      db_name: "adult_large",
      display_name: "Adult Large",
      up_charge: 0,
    },
    {
      db_name: "adult_xl",
      display_name: "Adult XL",
      up_charge: 0,
    },
    {
      db_name: "adult_2xl",
      display_name: "Adult 2XL",
      up_charge: 4,
    },
    {
      db_name: "adult_3xl",
      display_name: "Adult 3XL",
      up_charge: 4,
    },
  ],
  "452": [
    {
      db_name: "youth_small",
      display_name: "Youth Small",
      up_charge: 0,
    },
    {
      db_name: "youth_medium",
      display_name: "Youth Medium",
      up_charge: 0,
    },
    {
      db_name: "youth_large",
      display_name: "Youth Large",
      up_charge: 0,
    },
    {
      db_name: "adult_small",
      display_name: "Adult Small",
      up_charge: 0,
    },
    {
      db_name: "adult_medium",
      display_name: "Adult Medium",
      up_charge: 0,
    },
    {
      db_name: "adult_large",
      display_name: "Adult Large",
      up_charge: 0,
    },
    {
      db_name: "adult_xl",
      display_name: "Adult XL",
      up_charge: 0,
    },
    {
      db_name: "adult_2xl",
      display_name: "Adult 2XL",
      up_charge: 4,
    },
    {
      db_name: "adult_3xl",
      display_name: "Adult 3XL",
      up_charge: 4,
    },
  ],
  "454": [
    {
      db_name: "youth_small",
      display_name: "Youth Small",
      up_charge: 0,
    },
    {
      db_name: "youth_medium",
      display_name: "Youth Medium",
      up_charge: 0,
    },
    {
      db_name: "youth_large",
      display_name: "Youth Large",
      up_charge: 0,
    },
    {
      db_name: "adult_small",
      display_name: "Adult Small",
      up_charge: 0,
    },
    {
      db_name: "adult_medium",
      display_name: "Adult Medium",
      up_charge: 0,
    },
    {
      db_name: "adult_large",
      display_name: "Adult Large",
      up_charge: 0,
    },
    {
      db_name: "adult_xl",
      display_name: "Adult XL",
      up_charge: 0,
    },
    {
      db_name: "adult_2xl",
      display_name: "Adult 2XL",
      up_charge: 4,
    },
    {
      db_name: "adult_3xl",
      display_name: "Adult 3XL",
      up_charge: 4,
    },
  ],
  "456": [
    {
      db_name: "youth_small",
      display_name: "Youth Small",
      up_charge: 0,
    },
    {
      db_name: "youth_medium",
      display_name: "Youth Medium",
      up_charge: 0,
    },
    {
      db_name: "youth_large",
      display_name: "Youth Large",
      up_charge: 0,
    },
    {
      db_name: "adult_small",
      display_name: "Adult Small",
      up_charge: 0,
    },
    {
      db_name: "adult_medium",
      display_name: "Adult Medium",
      up_charge: 0,
    },
    {
      db_name: "adult_large",
      display_name: "Adult Large",
      up_charge: 0,
    },
    {
      db_name: "adult_xl",
      display_name: "Adult XL",
      up_charge: 0,
    },
    {
      db_name: "adult_2xl",
      display_name: "Adult 2XL",
      up_charge: 4,
    },
    {
      db_name: "adult_3xl",
      display_name: "Adult 3XL",
      up_charge: 4,
    },
  ],
  "458": [
    {
      db_name: "youth_small",
      display_name: "Youth Small",
      up_charge: 0,
    },
    {
      db_name: "youth_medium",
      display_name: "Youth Medium",
      up_charge: 0,
    },
    {
      db_name: "youth_large",
      display_name: "Youth Large",
      up_charge: 0,
    },
    {
      db_name: "adult_small",
      display_name: "Adult Small",
      up_charge: 0,
    },
    {
      db_name: "adult_medium",
      display_name: "Adult Medium",
      up_charge: 0,
    },
    {
      db_name: "adult_large",
      display_name: "Adult Large",
      up_charge: 0,
    },
    {
      db_name: "adult_xl",
      display_name: "Adult XL",
      up_charge: 0,
    },
    {
      db_name: "adult_2xl",
      display_name: "Adult 2XL",
      up_charge: 4,
    },
    {
      db_name: "adult_3xl",
      display_name: "Adult 3XL",
      up_charge: 4,
    },
  ],
  "460": [
    {
      db_name: "youth_small",
      display_name: "Youth Small",
      up_charge: 0,
    },
    {
      db_name: "youth_medium",
      display_name: "Youth Medium",
      up_charge: 0,
    },
    {
      db_name: "youth_large",
      display_name: "Youth Large",
      up_charge: 0,
    },
    {
      db_name: "adult_small",
      display_name: "Adult Small",
      up_charge: 0,
    },
    {
      db_name: "adult_medium",
      display_name: "Adult Medium",
      up_charge: 0,
    },
    {
      db_name: "adult_large",
      display_name: "Adult Large",
      up_charge: 0,
    },
    {
      db_name: "adult_xl",
      display_name: "Adult XL",
      up_charge: 0,
    },
    {
      db_name: "adult_2xl",
      display_name: "Adult 2XL",
      up_charge: 4,
    },
    {
      db_name: "adult_3xl",
      display_name: "Adult 3XL",
      up_charge: 4,
    },
  ],
  "476": [
    {
      db_name: "youth_small",
      display_name: "Youth Small",
      up_charge: 0,
    },
    {
      db_name: "youth_medium",
      display_name: "Youth Medium",
      up_charge: 0,
    },
    {
      db_name: "youth_large",
      display_name: "Youth Large",
      up_charge: 0,
    },
    {
      db_name: "adult_small",
      display_name: "Adult Small",
      up_charge: 0,
    },
    {
      db_name: "adult_medium",
      display_name: "Adult Medium",
      up_charge: 0,
    },
    {
      db_name: "adult_large",
      display_name: "Adult Large",
      up_charge: 0,
    },
    {
      db_name: "adult_xl",
      display_name: "Adult XL",
      up_charge: 0,
    },
    {
      db_name: "adult_2xl",
      display_name: "Adult 2XL",
      up_charge: 4,
    },
    {
      db_name: "adult_3xl",
      display_name: "Adult 3XL",
      up_charge: 4,
    },
  ],
  "478": [
    {
      db_name: "youth_small",
      display_name: "Youth Small",
      up_charge: 0,
    },
    {
      db_name: "youth_medium",
      display_name: "Youth Medium",
      up_charge: 0,
    },
    {
      db_name: "youth_large",
      display_name: "Youth Large",
      up_charge: 0,
    },
    {
      db_name: "adult_small",
      display_name: "Adult Small",
      up_charge: 0,
    },
    {
      db_name: "adult_medium",
      display_name: "Adult Medium",
      up_charge: 0,
    },
    {
      db_name: "adult_large",
      display_name: "Adult Large",
      up_charge: 0,
    },
    {
      db_name: "adult_xl",
      display_name: "Adult XL",
      up_charge: 0,
    },
    {
      db_name: "adult_2xl",
      display_name: "Adult 2XL",
      up_charge: 4,
    },
    {
      db_name: "adult_3xl",
      display_name: "Adult 3XL",
      up_charge: 4,
    },
  ],
  "480": [
    {
      db_name: "youth_small",
      display_name: "Youth Small",
      up_charge: 0,
    },
    {
      db_name: "youth_medium",
      display_name: "Youth Medium",
      up_charge: 0,
    },
    {
      db_name: "youth_large",
      display_name: "Youth Large",
      up_charge: 0,
    },
    {
      db_name: "adult_small",
      display_name: "Adult Small",
      up_charge: 0,
    },
    {
      db_name: "adult_medium",
      display_name: "Adult Medium",
      up_charge: 0,
    },
    {
      db_name: "adult_large",
      display_name: "Adult Large",
      up_charge: 0,
    },
    {
      db_name: "adult_xl",
      display_name: "Adult XL",
      up_charge: 0,
    },
    {
      db_name: "adult_2xl",
      display_name: "Adult 2XL",
      up_charge: 4,
    },
    {
      db_name: "adult_3xl",
      display_name: "Adult 3XL",
      up_charge: 4,
    },
  ],
  "482": [
    {
      db_name: "youth_small",
      display_name: "Youth Small",
      up_charge: 0,
    },
    {
      db_name: "youth_medium",
      display_name: "Youth Medium",
      up_charge: 0,
    },
    {
      db_name: "youth_large",
      display_name: "Youth Large",
      up_charge: 0,
    },
    {
      db_name: "adult_small",
      display_name: "Adult Small",
      up_charge: 0,
    },
    {
      db_name: "adult_medium",
      display_name: "Adult Medium",
      up_charge: 0,
    },
    {
      db_name: "adult_large",
      display_name: "Adult Large",
      up_charge: 0,
    },
    {
      db_name: "adult_xl",
      display_name: "Adult XL",
      up_charge: 0,
    },
    {
      db_name: "adult_2xl",
      display_name: "Adult 2XL",
      up_charge: 4,
    },
    {
      db_name: "adult_3xl",
      display_name: "Adult 3XL",
      up_charge: 4,
    },
  ],
  "484": [
    {
      db_name: "youth_small",
      display_name: "Youth Small",
      up_charge: 0,
    },
    {
      db_name: "youth_medium",
      display_name: "Youth Medium",
      up_charge: 0,
    },
    {
      db_name: "youth_large",
      display_name: "Youth Large",
      up_charge: 0,
    },
    {
      db_name: "adult_small",
      display_name: "Adult Small",
      up_charge: 0,
    },
    {
      db_name: "adult_medium",
      display_name: "Adult Medium",
      up_charge: 0,
    },
    {
      db_name: "adult_large",
      display_name: "Adult Large",
      up_charge: 0,
    },
    {
      db_name: "adult_xl",
      display_name: "Adult XL",
      up_charge: 0,
    },
    {
      db_name: "adult_2xl",
      display_name: "Adult 2XL",
      up_charge: 4,
    },
    {
      db_name: "adult_3xl",
      display_name: "Adult 3XL",
      up_charge: 4,
    },
  ],
  "486": [
    {
      db_name: "youth_small",
      display_name: "Youth Small",
      up_charge: 0,
    },
    {
      db_name: "youth_medium",
      display_name: "Youth Medium",
      up_charge: 0,
    },
    {
      db_name: "youth_large",
      display_name: "Youth Large",
      up_charge: 0,
    },
    {
      db_name: "adult_small",
      display_name: "Adult Small",
      up_charge: 0,
    },
    {
      db_name: "adult_medium",
      display_name: "Adult Medium",
      up_charge: 0,
    },
    {
      db_name: "adult_large",
      display_name: "Adult Large",
      up_charge: 0,
    },
    {
      db_name: "adult_xl",
      display_name: "Adult XL",
      up_charge: 0,
    },
    {
      db_name: "adult_2xl",
      display_name: "Adult 2XL",
      up_charge: 4,
    },
    {
      db_name: "adult_3xl",
      display_name: "Adult 3XL",
      up_charge: 4,
    },
  ],
  "701": [
    {
      db_name: "youth_small",
      display_name: "Youth Small",
      up_charge: 0,
    },
    {
      db_name: "youth_medium",
      display_name: "Youth Medium",
      up_charge: 0,
    },
    {
      db_name: "youth_large",
      display_name: "Youth Large",
      up_charge: 0,
    },
    {
      db_name: "adult_small",
      display_name: "Adult Small",
      up_charge: 0,
    },
    {
      db_name: "adult_medium",
      display_name: "Adult Medium",
      up_charge: 0,
    },
    {
      db_name: "adult_large",
      display_name: "Adult Large",
      up_charge: 0,
    },
    {
      db_name: "adult_xl",
      display_name: "Adult XL",
      up_charge: 0,
    },
    {
      db_name: "adult_2xl",
      display_name: "Adult 2XL",
      up_charge: 4,
    },
    {
      db_name: "adult_3xl",
      display_name: "Adult 3XL",
      up_charge: 4,
    },
  ],
  "703": [
    {
      db_name: "youth_small",
      display_name: "Youth Small",
      up_charge: 0,
    },
    {
      db_name: "youth_medium",
      display_name: "Youth Medium",
      up_charge: 0,
    },
    {
      db_name: "youth_large",
      display_name: "Youth Large",
      up_charge: 0,
    },
    {
      db_name: "adult_small",
      display_name: "Adult Small",
      up_charge: 0,
    },
    {
      db_name: "adult_medium",
      display_name: "Adult Medium",
      up_charge: 0,
    },
    {
      db_name: "adult_large",
      display_name: "Adult Large",
      up_charge: 0,
    },
    {
      db_name: "adult_xl",
      display_name: "Adult XL",
      up_charge: 0,
    },
    {
      db_name: "adult_2xl",
      display_name: "Adult 2XL",
      up_charge: 4,
    },
    {
      db_name: "adult_3xl",
      display_name: "Adult 3XL",
      up_charge: 4,
    },
  ],
  "705": [
    {
      db_name: "youth_small",
      display_name: "Youth Small",
      up_charge: 0,
    },
    {
      db_name: "youth_medium",
      display_name: "Youth Medium",
      up_charge: 0,
    },
    {
      db_name: "youth_large",
      display_name: "Youth Large",
      up_charge: 0,
    },
    {
      db_name: "adult_small",
      display_name: "Adult Small",
      up_charge: 0,
    },
    {
      db_name: "adult_medium",
      display_name: "Adult Medium",
      up_charge: 0,
    },
    {
      db_name: "adult_large",
      display_name: "Adult Large",
      up_charge: 0,
    },
    {
      db_name: "adult_xl",
      display_name: "Adult XL",
      up_charge: 0,
    },
    {
      db_name: "adult_2xl",
      display_name: "Adult 2XL",
      up_charge: 4,
    },
    {
      db_name: "adult_3xl",
      display_name: "Adult 3XL",
      up_charge: 4,
    },
  ],
};

export default clothing_sizes;
